<template>
  <v-app-bar flat dense color="primary" app dark>
      <v-toolbar-title>
      <router-link :to="{ name: titleRoute}" tag="span"
                  class="d-sm-flex align-center" style="cursor:pointer">
        <v-img contain
        height="40" class="mr-2" src="../assets/fandisentinel_logo_white_text_40.png"/>
      </router-link>
    </v-toolbar-title>
    <v-spacer/>
    <app-navigation/>
  </v-app-bar>
</template>

<script>
import appNavigation from '@/components/app-navigation.vue';

export default {
  name: 'Header',
  components: {
    appNavigation,
  },
  computed: {
    titleRoute() {
      if (this.$store.state.account.user?.userType === this.$auth.roles.provider) {
        return 'SelectFinanceCompany';
      }

      return 'Home';
    },
  },
};
</script>
